/**
 * 案例挂载仓库
 */
export default function (Vue) {
  Vue.prototype.$storeCase = new Vue({
    data () {
      return {
        // 人物 - 男
        man: [
          {
            img: require('/public/DigitalHuman/m1.png'),
            name: '男 - 1',
            audioID: 'x4_xiaoyan',
            video_output: require('/public/DigitalHuman/m1.mp4'),
            video_stationary: require('/public/DigitalHuman/m1_1.mp4')
          },
          {
            img: require('/public/DigitalHuman/m2.png'),
            name: '男 - 2',
            audioID: 'x4_xiaoyan',
            video_output: require('/public/DigitalHuman/m2.mp4'),
            video_stationary: require('/public/DigitalHuman/m2_1.mp4')
          }
        ],
        // 人物 - 女
        woman: [
          {
            img: require('/public/DigitalHuman/w1.png'),
            name: '女 - 1',
            audioID: 'x4_yezi',
            video_output: require('/public/DigitalHuman/w1.mp4'),
            video_stationary: require('/public/DigitalHuman/w1_1.mp4')
          },
          {
            img: require('/public/DigitalHuman/w2.png'),
            name: '女 - 2',
            audioID: 'x4_yezi',
            video_output: require('/public/DigitalHuman/w2.mp4'),
            video_stationary: require('/public/DigitalHuman/w2_1.mp4')
          },
          {
            img: require('/public/DigitalHuman/w3.png'),
            name: '女 - 3',
            audioID: 'x4_yezi',
            video_output: require('/public/DigitalHuman/w3.mp4'),
            video_stationary: require('/public/DigitalHuman/w3_1.mp4')
          }
        ],
        // 选择的数字参数
        figureConfig: {}
      }
    },
    methods: {
      // 预加载视频文件
      init() {
        let data = [...this.man, ...this.woman]
        let keys = ['video_output', 'video_stationary']
        for(let i = 0; i < data.length; i++){
          for(let key = 0; key < keys.length; key++){
            data[i].video = document.createElement('video')
            data[i].video.src = data[i][keys[key]]
            data[i].video.crossOrigin = 'anonymous'
            data[i].video.muted = true
            data[i].video.play()
            data[i].video.pause()
            data[i].video.currentTime = 0
          }
        }
      },

      // 重置数字人形象
      initFigure(obj){
        if(obj instanceof Object){
          let item = null
          if(obj.six == '男'){
            item = this.man[obj.index || 0]
          } else {
            item = this.woman[obj.index || 0]
          }
          this.figureConfig = item || {}
          sessionStorage.setItem('zntParam', JSON.stringify(obj))
        }
      }
    }
  })
}
